module.exports = __webpack_public_path__ + "media/images/windows@2x-fff9665c10006de189e4b67742649369.png";